import { faqData } from "@/mocks/categories";
import { useState } from "react";

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const toggleFAQ = (idx: number) => {
    setOpenIndex(openIndex === idx ? null : idx);
  };

  return (
    <section id="faq" className="w-full py-16 md:py-20 relative overflow-hidden">
      {/* Background Card */}
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="relative bg-foreground-950 rounded-2xl overflow-hidden">
          <div className="grid grid-cols-1 lg:grid-cols-5">
            {/* Left Image */}
            <div className="lg:col-span-2 relative h-64 lg:h-auto min-h-[320px] overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Minimalist%20flat%20lay%20of%20shopping%20research%20essentials%20including%20a%20tablet%20showing%20spreadsheet%20data%20magnifying%20glass%20and%20fashion%20accessories%20arranged%20on%20a%20dark%20charcoal%20surface%2C%20dramatic%20spotlight%20from%20top%20left%20creating%20strong%20contrast%2C%20moody%20editorial%20product%20photography%2C%20sophisticated%20noir%20aesthetic%20with%20warm%20amber%20accent%20light&width=700&height=900&seq=faq-img-v3&orientation=portrait"
                alt="VigorBuy Spreadsheet FAQ - Product research guide"
                className="w-full h-full object-cover"
                loading="lazy"
              />
            </div>

            {/* Right FAQ */}
            <div className="lg:col-span-3 p-8 md:p-12 flex flex-col justify-center">
              <p className="text-xs font-semibold uppercase tracking-wider text-accent-400 mb-2">FAQ</p>
              <h2 className="font-heading text-2xl md:text-3xl font-bold text-background-50 mb-8">
                Frequently Asked <span className="text-accent-400">Questions</span>
              </h2>

              <div className="space-y-1">
                {faqData.map((faq, idx) => (
                  <div key={idx} className="border-b border-foreground-700/30 last:border-0">
                    <button
                      onClick={() => toggleFAQ(idx)}
                      className="w-full flex items-center justify-between py-4 text-left cursor-pointer group"
                    >
                      <span className="text-sm md:text-base font-semibold text-background-50/90 pr-4 group-hover:text-background-50 transition-colors">
                        {faq.q}
                      </span>
                      <div className="w-6 h-6 flex items-center justify-center flex-shrink-0 text-accent-400">
                        <i
                          className={`text-sm transition-transform duration-300 ${
                            openIndex === idx ? "ri-subtract-line" : "ri-add-line"
                          }`}
                        ></i>
                      </div>
                    </button>
                    <div
                      className={`overflow-hidden transition-all duration-300 ${
                        openIndex === idx ? "max-h-60 pb-4" : "max-h-0"
                      }`}
                    >
                      <p className="text-sm text-foreground-300 leading-relaxed pr-8">{faq.a}</p>
                    </div>
                  </div>
                ))}
              </div>

              <div className="mt-8 flex items-center gap-4">
                <p className="text-xs text-foreground-400">
                  Community Verified &bull; Weekly Updated
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* FAQ Schema */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "FAQPage",
            mainEntity: faqData.map((faq) => ({
              "@type": "Question",
              name: faq.q,
              acceptedAnswer: {
                "@type": "Answer",
                text: faq.a,
              },
            })),
          }),
        }}
      />
    </section>
  );
}